import { BOX_TYPE_FOR_SELECTION } from 'swag-common/constants/product.constants';
export function isBoxType(swagProduct) {
  return !!(swagProduct !== null && swagProduct !== void 0 && swagProduct.specialProductType) && BOX_TYPE_FOR_SELECTION.includes(swagProduct === null || swagProduct === void 0 ? void 0 : swagProduct.specialProductType);
}